export const isCustomerPortalInBuilderMode = () =>
  !!document.querySelector('[data-preview-mode="false"]');

export const isCustomerPortalInPreviewMode = () =>
  window !== window?.top &&
  !!window.parent.document.querySelector('#cp-live-preview');

export const isCustomerPortal = () =>
  !!document.querySelector('.rl-cp-top-scroll-wrapper');
